module.exports = __webpack_public_path__ + "img/canada.5dae90c.webp";